export default __webpack_public_path__ + "img/594d97c44807a36592c5eec6c10fa8c9.svg";